import React, { useState, useEffect } from 'react';
import { ThemeProvider } from 'styled-components';
//import FontFaceObserver from 'fontfaceobserver';
import { useNavigate } from 'react-router-dom';
import GlobalStyle from './GlobalStyle';
import Footer from '../components/footer/Footer';
import NewNavbar from '../components/header/navbar';
import theme from './theme';

const MainLayout = ({
  children,
  page,
  // withoutFooter,
  path,
  className,
}) => {
  const [fontLoaded, setFontLoaded] = useState(true);
  const history = useNavigate();

  // useEffect(() => {
  //   const fontA = new FontFaceObserver('Montserrat');
  //   const fontB = new FontFaceObserver('Bemio');

  //   Promise.all([fontA.load(), fontB.load()]).then(() => {
  //     setFontLoaded(true);
  //   });
  // }, []);

  useEffect(() => {
    /*const font = new FontFaceObserver('Inter');
    font
      .load()
      .then(() => {
        setFontLoaded(true);
      })
      .catch(error => {
        console.error('Error al cargar la fuente:', error);
      });*/
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <div style={{ overflow: 'hidden' }}>
        {fontLoaded && <GlobalStyle />}
        {/*<NewHeader
          path={path}
          category={category || 'TODAS'}
          page={page}
          history={useNavigate}
          />*/}
        <NewNavbar />
        <div style={{ minHeight: '100vh' }} className={className}>
          {children}
        </div>
        <Footer />
      </div>
    </ThemeProvider>
  );
};

export default MainLayout;
